import React from "react";

import { Grid } from "@mui/material";

import { ComplaintForm } from "./fb-elements/index";

const FormLayouts = () => {
  return (
    <Grid container spacing={0}>
      <Grid item lg={12} md={12} xs={12}>
        <ComplaintForm />
      </Grid>
    </Grid>
  );
};

export default FormLayouts;
